
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groups/discover",
      function () {
        return require("private-next-pages/groups/discover.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groups/discover"])
      });
    }
  